import { supportTelegram } from './legal'

/** The bot's page on t.me: a phone hands it to the Telegram app; a desktop without the app shows a card that opens nothing. */
export const telegramAppUrl = `https://t.me/${supportTelegram}`
/** The bot's chat in Telegram Web, which needs no installation. */
export const telegramWebUrl = `https://web.telegram.org/k/#@${supportTelegram}`

/** Whether this device opens t.me in the Telegram app: a phone or a tablet, judged by its touch pointer or its platform. */
export function opensTelegramApp() {
  const coarse = typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches
  return coarse || /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
}

/** Where a plain link sends the visitor: the app where it opens t.me, Telegram Web elsewhere. */
export function telegramDirectUrl() {
  return opensTelegramApp() ? telegramAppUrl : telegramWebUrl
}
